function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_595",
  "data-name": "Group 595",
  transform: "translate(30.042 25.625) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_135",
  "data-name": "Group 135",
  transform: "translate(3.221 5.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_134",
  "data-name": "Group 134",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_133",
  "data-name": "Group 133"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M10.676,23.363a1.682,1.682,0,0,1,0-3.363H31.707a1.682,1.682,0,0,1,0,3.363Z",
  transform: "translate(-9 -11.677)",
  fill: "#999",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M38.194,21.294,29.87,29.618a1.682,1.682,0,0,1-2.378-2.379l7.134-7.134-7.134-7.134a1.682,1.682,0,0,1,2.378-2.379l8.324,8.324A1.681,1.681,0,0,1,38.194,21.294Z",
  transform: "translate(-11.866 -10.1)",
  fill: "#999",
  fillRule: "evenodd"
})))));

var SvgBackButton = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.82,
    height: 20.01,
    viewBox: "0 0 26.82 20.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back-button.afebf936.svg";
export { ForwardRef as ReactComponent };